module.exports = __webpack_public_path__ + "static/media/09_6_WHEEL_Team-HERL-wheels_AlessandroDellaBella_042.947345b4.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Particles/Particle09/09_6_WHEEL_Team-HERL-wheels_AlessandroDellaBella_042.jpg
 ** module id = 146
 ** module chunks = 0
 **/